'use client';

import styled from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  gap: 8px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column-reverse;
  }
`;

export const Grade = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;

  font-weight: 800;

  border: 1px solid ${colors.gray3};

  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;

  color: ${colors.brown};

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: row;

    margin: 16px 0 0 0;
  }
`;

export const InfoBadges = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: ${({ $numItems }) => ($numItems > 4 ? 'flex-start' : 'space-between')};
  gap: 8px;

  margin: 16px 0;
  width: 100%;
  padding: 16px;

  border: 1px solid ${colors.gray3};
  border-radius: 8px;

  & > * {
    ${({ $numItems }) => $numItems > 4 && 'min-width: calc(33% - 8px)'};
  }

  @media (max-width: ${breakpoints.tablet}) {
    justify-content: center;
  }
`;

export const VideoWrap = styled.div`
  width: 100%;
  height: auto;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  margin: 0 auto;
  gap: 96px;

  @media (max-width: ${breakpoints.laptop}) {
    gap: 48px;
  }
`;

export const Description = styled.div`
  h1 {
    font-size: 2.2rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h2 {
    font-size: 2rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h3 {
    font-size: 1.8rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h4 {
    font-size: 1.6rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h5 {
    font-size: 1.4rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h6 {
    font-size: 1.2rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  blockquote {
  }
  ul {
    padding-left: 24px;
  }
  ol {
  }
  a {
    text-decoration: underline;
    color: ${colors.aqua};
  }
  p,
  li {
    font-size: 1.2rem;
    line-height: 1.5;
    font-weight: 400;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    margin: 5px 0;
  }
  code {
    background-color: #f4f4f4;
    border: 1px solid #ddd;
    border-left: 3px solid #000;
    color: #666;
    page-break-inside: avoid;
    font-family: monospace;
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1.6em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
  }

  @media (max-width: ${breakpoints.tablet}) {
    p {
      font-size: 1rem;
    }

    h1 {
      font-size: 2rem;
      margin: 10px 0 10px;
    }
    h2 {
      font-size: 1.8rem;
      margin: 10px 0 10px;
    }
    h3 {
      font-size: 1.6rem;

      margin: 10px 0 10px;
    }
    h4 {
      font-size: 1.4rem;

      margin: 10px 0 10px;
    }
    h5 {
      font-size: 1.2rem;

      margin: 10px 0 10px;
    }
    h6 {
      font-size: 1.1rem;

      margin: 10px 0 10px;
    }
    li {
      font-size: 1rem;
    }
    blockquote {
      margin: 1rem 0;
      padding: 4rem 0;
    }
    ul {
      margin: 10px 0 0 20px;
    }
    ol {
      margin: 10px 0 0 20px;
    }
  }
`;

export const TablesWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InfoTable = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 34px 42px;
  gap: 12px;

  border-radius: 16px;
  border: 1px solid ${colors.gray3};

  @media (max-width: ${breakpoints.mobile}) {
    padding: 16px 8px;
    border-radius: 8px;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;

  gap: 10px;

  font-size: 1.1rem;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 1rem;
  }
`;

export const SubtitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${breakpoints.mobile}) {
    justify-content: center;
  }
`;

export const Subtitle = styled.h1`
  font-size: ${({ $small }) => ($small ? '1.5rem' : '2.5rem')};
  color: ${({ $color }) => colors[$color] || colors.blue};
  text-transform: ${({ $caps }) => ($caps ? 'uppercase' : 'none')};
  opacity: 0.7;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.9rem;
    ${({ $small }) => $small && 'font-size: 0.9rem;'}
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;

  gap: 32px;
`;

export const Line = styled.div`
  display: flex;
  flex-grow: 1;

  margin-left: 16px;

  border-top: 1px solid ${({ $color }) => colors[$color] || colors.blue};

  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

export const PlansSection = styled.div`
  display: flex;
  flex-direction: column;

  gap: 24px;
`;

export const SwitchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 16px;

  .mantine-Switch-track {
    border: 1px solid ${colors.brown};
    background-color: ${colors.gray2};

    &:hover {
      cursor: pointer;
    }
  }

  .mantine-Switch-thumb {
    background-color: ${({ $color }) => ($color ? $color : colors.gray5)};
  }
`;

export const SwitchLabel = styled.span`
  width: 104px;

  font-size: 1.125rem;
  font-weight: ${({ $active }) => ($active ? 700 : 400)};
  text-transform: uppercase;
  color: ${({ $color }) => ($color ? $color : colors.gray5)};
  transition: all 0.2s ease-in-out;
`;
